import { ApiFetcher } from "./ApiFetcher";


export interface P1RawDataPoint {
  curs_academic: string;
  sistema: string;
  ambit_estudi: string;
  ratio: number;
}

export interface P2RawDataPoint {
  any: number;
  sistema: string;
  ambit: string;
  ratio: number;
}

export interface P3RawDataPoint {
  any: number;
  mode_escenari: string;
  desajust: number;
}

export interface P4RawDataPoint {
  nom_titulacio: string;
  any: number;
  taxa_ocupacio_pct: number;
  taxa_adequacio_pct: number;
  taxa_sobrequalificacio_pct: number;
  index_desajust: number;
}

export interface P5RawDataPoint {
  nom_comarca: string;
  nom_sector: string;
  places_sector: number;
  iaup: number;
}

class ChartDataFetch {
  private readonly cache = new Map<string, unknown>();

  getCachedSync<T>(key: string): T | null {
    return (this.cache.get(key) as T) ?? null;
  }

  async getP1Data(): Promise<P1RawDataPoint[]> {
    if (this.cache.has("p1")) return this.cache.get("p1") as P1RawDataPoint[];
    const { data } = await new ApiFetcher().callApi<P1RawDataPoint[]>({ endpoint: "db/p1" });
    const result = data ?? [];
    this.cache.set("p1", result);
    return result;
  }

  async getP2Data(): Promise<P2RawDataPoint[]> {
    if (this.cache.has("p2")) return this.cache.get("p2") as P2RawDataPoint[];
    const { data } = await new ApiFetcher().callApi<P2RawDataPoint[]>({ endpoint: "db/p2" });
    const result = data ?? [];
    this.cache.set("p2", result);
    return result;
  }

  async getP3Data(): Promise<P3RawDataPoint[]> {
    if (this.cache.has("p3")) return this.cache.get("p3") as P3RawDataPoint[];
    const { data } = await new ApiFetcher().callApi<P3RawDataPoint[]>({ endpoint: "db/p3" });
    const result = data ?? [];
    this.cache.set("p3", result);
    return result;
  }

  async getP4Data(): Promise<P4RawDataPoint[]> {
    if (this.cache.has("p4")) return this.cache.get("p4") as P4RawDataPoint[];
    const { data } = await new ApiFetcher().callApi<P4RawDataPoint[]>({ endpoint: "db/p4" });
    const result = data ?? [];
    this.cache.set("p4", result);
    return result;
  }

  async getP5Data(): Promise<P5RawDataPoint[]> {
    if (this.cache.has("p5")) return this.cache.get("p5") as P5RawDataPoint[];
    const { data } = await new ApiFetcher().callApi<P5RawDataPoint[]>({ endpoint: "db/p5" });
    const result = data ?? [];
    this.cache.set("p5", result);
    return result;
  }
}

const chartDataFetcher = new ChartDataFetch();

export default chartDataFetcher;
